import { useForm } from '@/common/form/FormContext';
import { PercentFormField } from '@/common/form/formFields/PercentFormField';
import { TextFormField } from '@/common/form/formFields/TextFormField';
import { TextField } from '@mui/material';
import { useEffect, useRef } from 'react';
import { ProgProdFormulaValue } from './formula/ProgProdFormulaValue';

const calcTypeToFormField = {
  FORMULA: ProgProdFormulaValue,
  PCT_OFF: PercentFormField,
  MAX_ALLOWED_PCT: PercentFormField,
};

// Shared by ProgProd's value and Tier's disc; both are entered in the unit of the ProgProdCalcType
export const CalcTypeValue = ({ fieldDef, fallback: Fallback = TextFormField, disableWithoutCalcType = false }) => {
  const { formValues, assignValue } = useForm();
  const calcType = formValues.progProdCalcType;
  const value = formValues[fieldDef.field];

  // Picking a different FormField component per calc type (below) unmounts the previous one, which runs the shared
  // Form's unmount-cleanup and nulls this field out - it's still logically in use, just rendered by a different
  // component, so restore the last known value when that cleanup nulling is detected (value === null exactly).
  const lastValueRef = useRef(value);
  useEffect(() => {
    if (value === null && lastValueRef.current !== null) {
      assignValue(fieldDef.field, lastValueRef.current);
    } else {
      lastValueRef.current = value;
    }
  }, [value]);

  if (!calcType && disableWithoutCalcType) return <TextField label={fieldDef.displayName} disabled={true} />;

  const FieldComponent = calcTypeToFormField[calcType] ?? Fallback;

  const effectiveFieldDef =
    FieldComponent === PercentFormField ?
      { ...fieldDef, decimalPrecision: fieldDef.decimalPrecision >= 0 ? fieldDef.decimalPrecision : 2 }
    : fieldDef;

  return <FieldComponent key={calcType ?? 'default'} fieldDef={effectiveFieldDef} />;
};
